/**
 * Assets and copy used by the live homepage facelift.
 * The old Home.tsx file is kept in the repo for git rollback only.
 */

/** Cropped storefront (Opening Tomorrow sign removed). */
export const PREVIEW_HERO_IMAGE = '/assets/images/exterior/storefront-hero.webp';

/**
 * Visit-strip crop of the storefront windows (HOT & FRESH / logo / coffee).
 * Do not crop the entry door. The door lettering says NUT FRIENDLY, but
 * the bakery is not nut-friendly. They sell Nutella, peanut buttercup, Ferrero.
 */
export const PREVIEW_VISIT_IMAGE = '/assets/images/exterior/storefront-visit.webp';

/**
 * Hero words Tammy already uses on the live homepage.
 * Do not rewrite this sentence.
 */
export const PREVIEW_HERO_TITLE = 'Fresh Baked Goods Made with Love';
export const PREVIEW_HERO_DESCRIPTION =
  "Visit Nanny B's Bakery in Barrie, Ontario for delicious cakes, pastries, and custom treats.";

/**
 * Trust chips on the preview hero.
 * Never add "Nut friendly" or "nut-free" here. Tammy confirmed the shop is not
 * nut friendly. Gluten-free options is OK (window sign + FAQ).
 */
export const PREVIEW_TRUST_CHIPS = [
  'Gluten-free options',
  'Custom cakes',
  '5.0 on Google',
  'Pickup in Barrie',
] as const;
